import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { authApi } from '../lib/authApi';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Tri-state user: null (checking), object (authenticated), false (not authenticated)
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const u = await authApi.me();
      setUser(u);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from Emergent OAuth callback, skip the /me check.
    // The AuthCallback page will exchange the session_id and establish the
    // session first; running checkAuth here would 401 racily and bounce users.
    if (typeof window !== 'undefined' && window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const value = {
    user,
    loading,
    refresh: checkAuth,
    setUser, // for direct updates from callback flows
    isAuthed: !!user,
    isAdmin: user?.role === 'admin',
    logout: async () => {
      try { await authApi.logout(); } catch { /* ignore */ }
      setUser(false);
    },
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}
